import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import * as serviceWorker from "./serviceWorker"
import "./assets/css/bootstrap.min.css"
import "./assets/css/animate.css"
import "./assets/css/default.css"
import "./assets/css/style.css"
import Home from "./pages/home"
import Fpl from "./pages/fpl"
import FastRis from "./pages/FastRis"
import ImageSearch from "./pages/ImageSearch"
import AiImageDetection from "./pages/ai-image-detection"
import C2paAiDetector from "./pages/c2pa-ai-detector"
import Kyt from "./pages/kyt"
import FastingSense from "./pages/FastingSense"
import ClashTrophy from "./pages/clashtrophy"
import Jobyne from "./pages/jobyne"
import AiSmartGallery from "./pages/AiSmartGallery"

import FplPolicy from "./pages/fpl-privacy-policy"
import fastrisPolicy from "./pages/fastris-privacy-policy"
import imagesearchPolicy from "./pages/imagesearch-privacy-policy"
import aiImageDetectionPolicy from "./pages/ai-image-detection-privacy-policy"
import c2paAiDetectorPolicy from "./pages/c2pa-ai-detector-privacy-policy"
import kytPolicy from "./pages/kyt-privacy-policy"
import fastingSensePolicy from "./pages/fastingsense-privacy-policy"
import clashtrophyPolicy from "./pages/clashtrophy-privacy-policy"
import jobynePolicy from "./pages/jobyne-privacy-policy"
import aiSmartGalleryPolicy from "./pages/AiSmartGallery-privacy-policy"

import FplTerms from "./pages/fpl-terms-and-conditions"
import fastrisTerms from "./pages/fastris-terms-and-conditions"
import imagesearchTerms from "./pages/imagesearch-terms-and-conditions"
import aiImageDetectionTerms from "./pages/ai-image-detection-terms-and-conditions"
import c2paAiDetectorTerms from "./pages/c2pa-ai-detector-terms-and-conditions"
import kytTerms from "./pages/kyt-terms-and-conditions"
import fastingSenseTerms from "./pages/fastingsense-terms-and-conditions"
import clashtrophyTerms from "./pages/clashtrophy-terms-and-conditions"
import jobyneTerms from "./pages/jobyne-terms-and-conditions"
import aiSmartGalleryTerms from "./pages/AiSmartGallery-terms-and-conditions"

import Privacy from "./pages/privacy-policy"
import ScrollToTop from "./ScrollToTop"

const App = () => (
  <Router>
    <ScrollToTop />
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/privacy-policy" component={Privacy} />

      <Route exact path="/faceit-pro-league" component={Fpl} />
      <Route
        exact
        path="/faceit-pro-league/terms-and-conditions"
        component={FplTerms}
      />
      <Route exact path="/faceit-pro-league/privacy-policy" component={FplPolicy} />

      <Route exact path="/fastris" component={FastRis} />
      <Route exact path="/fastris/terms-and-conditions" component={fastrisTerms} />
      <Route exact path="/fastris/privacy-policy" component={fastrisPolicy} />

      <Route exact path="/image-search" component={ImageSearch} />
      <Route exact path="/image-search/terms-and-conditions" component={imagesearchTerms} />
      <Route exact path="/image-search/privacy-policy" component={imagesearchPolicy} />

      <Route exact path="/ai-image-detection" component={AiImageDetection} />
      <Route exact path="/ai-image-detection/terms-and-conditions" component={aiImageDetectionTerms} />
      <Route exact path="/ai-image-detection/privacy-policy" component={aiImageDetectionPolicy} />

      <Route exact path="/c2pa-ai-detector" component={C2paAiDetector} />
      <Route exact path="/c2pa-ai-detector/terms-and-conditions" component={c2paAiDetectorTerms} />
      <Route exact path="/c2pa-ai-detector/privacy-policy" component={c2paAiDetectorPolicy} />

      <Route exact path="/kolay-yemek-tarifleri" component={Kyt} />
      <Route exact path="/kolay-yemek-tarifleri/terms-and-conditions" component={kytTerms} />
      <Route exact path="/kolay-yemek-tarifleri/privacy-policy" component={kytPolicy} />

      <Route exact path="/fastingsense" component={FastingSense} />
      <Route exact path="/fastingsense/terms-and-conditions" component={fastingSenseTerms} />
      <Route exact path="/fastingsense/privacy-policy" component={fastingSensePolicy} />

      <Route exact path="/clashtrophy" component={ClashTrophy} />
      <Route exact path="/clashtrophy/terms-and-conditions" component={clashtrophyTerms} />
      <Route exact path="/clashtrophy/privacy-policy" component={clashtrophyPolicy} />

      <Route exact path="/jobyne" component={Jobyne} />
      <Route exact path="/jobyne/terms-and-conditions" component={jobyneTerms} />
      <Route exact path="/jobyne/privacy-policy" component={jobynePolicy} />

      <Route exact path="/AiSmartGallery" component={AiSmartGallery} />
      <Route exact path="/AiSmartGallery/terms-and-conditions" component={aiSmartGalleryTerms} />
      <Route exact path="/AiSmartGallery/privacy-policy" component={aiSmartGalleryPolicy} />
    </Switch>
  </Router>
)

ReactDOM.render(<App />, document.getElementById("root"))
serviceWorker.unregister()
